import { render, staticRenderFns } from "./CopyBox.vue?vue&type=template&id=37f4511a"
import script from "./CopyBox.vue?vue&type=script&lang=js"
export * from "./CopyBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports